module.exports = __webpack_public_path__ + "img/300x200.8a4adcd7.png";